import React from "react";
import { isMobileDevice } from "../../../utils/getPlatformInfo";
import styles from "../index.module.scss";

const speakersToShow = isMobileDevice ? 3 : 4;
const Speakers = ({ speakersList, handleShowSpeakers, index }) => {
  const handleSpeakerClick=(e)=>{
    e.stopPropagation()
    handleShowSpeakers(speakersList, index)
  }
  return (
    <div className={styles.speakers} onClick={(e)=>handleSpeakerClick(e)}>
      {speakersList.slice(0, speakersToShow).map((speaker, ind) => {
        return (
          <React.Fragment key={ind}>
            <img
              data-aos="fade-left"
              data-aos-delay={ind * 100}
              data-aos-offset="-10"
              key={ind}
              src={speaker.photoUrl}
              alt={`speaker${ind}`}
              className={styles.speakerImg}
              style={{
                position: "absolute",
                left: `${ind * (isMobileDevice ? 24 : 30)}px`,
              }}
            />
            {ind === speakersToShow-1 && speakersList.length - speakersToShow!=0 ? (
              <div
                className={styles.remainCount}
                data-aos="fade-up"
                data-aos-delay={speakersToShow - 1 * 100}
              >
                +{speakersList.length - speakersToShow}
              </div>
            ) : null}
          </React.Fragment>
        );
      })}
      <div className={styles.speakerText}>Speakers</div>

    </div>
  );
};

export default Speakers;
